export default {
  name: 'lifeEventTheme',
  subtitle: 'Themes are a collection of Encouragement Categories',
  isPublishable: true,
  uniqKey: '_id',
  crudMapping: {
    create: 'createLifeEventTheme',
    readMany: 'curatorLifeEventThemes',
    readOne: 'lifeEventTheme',
    update: 'updateLifeEventTheme',
    // delete: 'deleteLifeEventTheme',
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === 'published') {
        return value ? 'Yes' : 'No';
      }
      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
        },
        published: {
          type: 'boolean',
        },
      },
    },
  },
  updateSchema: {
    jsonSchema: {
      title: 'Life Event Theme',
      type: 'object',
      required: ['title', 'image', 'lifeEventCategoryIds', 'companyIds'],
      properties: {
        title: {
          type: 'string',
        },
        description: {
          type: 'string',
          description:
            'Enter the description for this life event theme. This field has a 280 character limit.',
          maxLength: 280,
        },
        image: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
          default: 1000,
        },
        lifeEventCategoryIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
        },
        companyIds: {
          title: 'Associated Companies',
          type: 'array',
          items: {
            type: 'string',
          },
        },
        published: {
          type: 'boolean',
          default: true,
          title: 'Published',
        },
        hidden: {
          type: 'boolean',
          default: false,
          title: 'Hide from frontend',
        },
      },
    },
    uiSchema: {
      published: {
        'ui:widget': 'hidden',
      },
      lifeEventCategoryIds: {
        'ui:field': 'hasManyField',
        'ui:options': {
          sortable: true,
        },
      },
      companyIds: {
        'ui:field': 'hasManyField',
      },
      image: {
        'ui:widget': 'imageWidget',
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Life Event Theme',
      type: 'object',
      required: ['title', 'image', 'lifeEventCategoryIds', 'companyIds'],
      properties: {
        title: {
          type: 'string',
        },
        description: {
          type: 'string',
        },
        image: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
          default: 1000,
        },
        lifeEventCategoryIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
        },
        companyIds: {
          title: 'Associated Companies',
          type: 'array',
          items: {
            type: 'string',
          },
        },
        published: {
          type: 'boolean',
          default: true,
          title: 'Published',
        },
        hidden: {
          type: 'boolean',
          default: false,
          title: 'Hide from frontend',
        },
      },
    },
    uiSchema: {
      published: {
        'ui:widget': 'hidden',
      },
      lifeEventCategoryIds: {
        'ui:field': 'hasManyField',
        'ui:options': {
          sortable: true,
        },
      },
      companyIds: {
        'ui:field': 'hasManyField',
      },
      image: {
        'ui:widget': 'imageWidget',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/curator/lifeEventTheme.js